import api from './api';

let cachedVapidKey = undefined; // undefined = not yet fetched, '' = fetched but empty

async function fetchVapidKey() {
  if (cachedVapidKey !== undefined) return cachedVapidKey;
  try {
    const res = await api.get('/push/vapid-key');
    cachedVapidKey = res.data.public_key || '';
  } catch {
    cachedVapidKey = '';
  }
  return cachedVapidKey;
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

// Returns true if the browser supports push AND the server has VAPID configured.
export async function isPushConfigured() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  const key = await fetchVapidKey();
  return !!key;
}

// Returns { ok: true } on success, or { ok: false, reason: string } on failure.
export async function subscribeToPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return { ok: false, reason: 'unsupported' };
  }

  // Fetch VAPID key first — don't prompt the browser if the server isn't configured.
  const key = await fetchVapidKey();
  if (!key) {
    return { ok: false, reason: 'not_configured' };
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return { ok: false, reason: 'permission_denied' };
    }

    const reg = await navigator.serviceWorker.register('/sw.js');
    await navigator.serviceWorker.ready;

    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(key),
    });

    const subJson = sub.toJSON();
    await api.post('/push/subscribe', {
      endpoint: subJson.endpoint,
      keys: subJson.keys,
    });

    return { ok: true };
  } catch (err) {
    console.error('Push subscription failed:', err);
    return { ok: false, reason: 'error' };
  }
}

export async function isPushSubscribed() {
  if (!('serviceWorker' in navigator)) return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw.js');
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}
